import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

const NotFound = () => (
  <div className="max-w-3xl mx-auto container-px py-32 text-center" data-testid="not-found-page">
    <p className="text-xs uppercase tracking-[0.22em] text-primary font-semibold">404</p>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-medium tracking-tight">
      This page swam away.
    </h1>
    <p className="mt-6 text-lg text-foreground/70">
      Let's get you back to somewhere useful.
    </p>
    <Button asChild className="mt-8 rounded-full bg-primary text-primary-foreground h-13 px-7" data-testid="notfound-home-cta">
      <Link to="/">
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back home
      </Link>
    </Button>
  </div>
);

export default NotFound;
